(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ah-product-commerce"]) return;
  try {
    
document.addEventListener('change',function(event){if(!event.target.matches('[data-mm-variant]'))return;const root=event.target.closest('[data-mm-product]');const option=event.target.selectedOptions[0];if(root&&option&&option.dataset.price)root.querySelector('[data-mm-price]').textContent=option.dataset.price;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-comparison"] && !Shopify.designMode) return;
  try {
    
function mmComparisonOpen(){const e=document.getElementById(location.hash.slice(1));if(e&&e.tagName==='DETAILS')e.open=true;}
window.addEventListener('hashchange',mmComparisonOpen);mmComparisonOpen();

  } catch(e) { console.error(e); }
})();
})();
